import React, {useState} from "react";
import {Link} from 'react-router-dom'

import Egg from "../../images/egg.png";
import Play from "../../images/play.svg";

import LazyLoad from 'react-lazyload';

const Slogan = () => {
  const [isHidden, setIsHidden] = useState(true);
  
  const onPlayClick = () => {
    setIsHidden(false);
  };

  const onCloseClick = () => {
    setIsHidden(true);
  };

  return (
    <section id="slogan">
      <div className="px-4 py-5 container-fluid">
        <div className="row no-gutters">
          <div className="col-12 col-md-5 offset-md-1">
            <p className="colorful-text">NFTS + EGGS = NIFTYEGGS
              <span role="img" aria-labelledby="jsx-a11y/accessible-emoji" area-label="wink">&#128521;</span>
            </p>

            <h2>Farm NFTs by locking up ERC20 tokens!</h2>
            <p className="mt-3">
              You can create a limited edition NFTs to reward the token community for locking up their tokens for some period of time.
              Or you can lock your tokens and farm already created NFTs.
            </p>
            <p className="tags">There is an extra reward of NEGG governance token for farming some NFTs!</p>
            
            <div className="d-flex align-items-center">
              <Link className="btn btn-primary btn-scale my-4 mr-2" to="/create">Create</Link>
              <span>OR</span>
              <Link className="btn btn-primary btn-scale my-4 ml-2" to="/farm">Farm</Link>
            </div>

            <p className="mt-5 mb-0 colorful-text">Powered by
              <a href="https://matic.network/" target="blank">
                <svg xmlns="http://www.w3.org/2000/svg" id="matic-logo" viewBox="0 0 131 32">
                  <g fill="none" fillRule="evenodd">
                    <path fill="#FFF"
                          d="M85.029 22.854c1.39 0 2.56-.467 3.484-1.382.924-.96 1.39-2.13 1.39-3.548 0-1.417-.466-2.588-1.39-3.512-.924-.95-2.094-1.417-3.484-1.417-1.382 0-2.551.466-3.475 1.417-.924.924-1.381 2.095-1.381 3.512 0 1.417.457 2.588 1.38 3.548.925.915 2.094 1.382 3.476 1.382zm4.874-12.631h3.325v15.404h-3.325v-2.219c-1.267 1.762-3.053 2.624-5.393 2.624-2.12 0-3.915-.775-5.42-2.342-1.504-1.575-2.243-3.52-2.243-5.766 0-2.28.739-4.189 2.244-5.765 1.504-1.567 3.299-2.342 5.419-2.342 2.34 0 4.126.863 5.393 2.588v-2.182zm16.213 3.203h-3.818v7.395c0 1.972 1.294 1.936 3.818 1.813v2.993c-5.085.616-7.143-.775-7.143-4.806v-7.395H96.14v-3.204h2.833l-.006-4.314h3.331v4.314h3.818v3.204zm3.044 12.201h3.326V10.222h-3.325v15.405zm.15-18.327c-.836-.863-.836-2.166 0-2.994a2.082 2.082 0 013.017 0c.827.828.827 2.13-.035 2.994-.826.827-2.12.827-2.982 0zm8.48 16.39c-1.539-1.576-2.313-3.486-2.313-5.766 0-2.314.774-4.216 2.314-5.765 1.575-1.567 3.51-2.342 5.815-2.342 2.991 0 5.64 1.55 6.87 3.98l-2.858 1.663c-.713-1.48-2.19-2.368-4.038-2.368-1.355 0-2.49.457-3.423 1.382-.888.924-1.354 2.069-1.354 3.45 0 1.382.466 2.527 1.354 3.451.933.925 2.068 1.382 3.423 1.382 1.821 0 3.351-.915 4.09-2.368l2.868 1.629c-1.319 2.464-3.94 4.014-6.932 4.014-2.305 0-4.24-.775-5.815-2.342"/>
                    <path fill="#2BBDF7" d="M15.701 13.193l4.464 9.9 6.644-3.83.005-.002v-7.666z"/>
                    <path fill="#2891F9"
                          d="M35.394 5.847l-4.147-1.562-4.432-.358V27.75l6.649 3.832 5.248-10.74-3.31-10.385z"/>
                    <path fill="#2BBDF7" d="M35.005 3.929l-1.54 3.831h-.002v23.82l6.65-3.831V3.929z"/>
                    <path fill="#2B6DEF" d="M33.464.095l-6.65 3.834 6.65 3.833 6.65-3.833z"/>
                    <path fill="#2891F9"
                          d="M20.168 15.424v-.002l-6.649-7.44L.22 3.926v23.82l6.648 3.833 1.9-13.182 4.751.863v-.004l6.65 3.832v-7.664z"/>
                    <path fill="#FFF"
                          d="M70.32 5.909l-6.527 10.783-6.501-10.783h-3.819v19.718h3.546V12.07l5.87 9.743h1.804l5.874-9.709v13.522h3.576V5.909z"/>
                    <path fill="#2B6DEF" d="M6.87.094L.218 3.927l19.946 11.502 3.014-1.737 3.635-2.097z"/>
                    <path fill="#2BBDF7" d="M6.87 15.425h-.001v16.154l6.65-3.832v-8.489z"/>
                  </g>
                </svg>
              </a>
            </p>

            <div className="mt-5">
              <LazyLoad once={true}>
                <button type="button" className="btn btn-link p-0 m-0" onClick={onPlayClick}>
                  <img src={Play} alt="play video" className="d-inline-block play-img"/>
                </button>
                <span className="ml-2">What it is all about?</span>
              </LazyLoad>
            </div>

            <div className={isHidden ? 'd-none' : ''}>
              <div className="img-modal">
                  <span className="img-modal-close" onClick={onCloseClick}>&times;</span>
                  <iframe 
                    className="video-about"
                    title="Video about NiftyEggs" 
                    src="https://www.youtube.com/embed/4Vjg96b2alw" 
                    frameBorder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowtransparency={'true'}
                    allowFullScreen={true}
                    webkitallowfullscreen={'true'}
                    mozallowfullscreen={'true'}>
                  </iframe>
              </div>
            </div>

          </div>
          <div className="col-12 col-md-5 offset-lg-1 mt-5">
            <LazyLoad once={true}>
              <img src={Egg} alt="An egg"/>
            </LazyLoad>
          </div>
        </div>
      </div>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path fill="#0090FF" fillOpacity="1"
              d="M0,128L30,160C60,192,120,256,180,245.3C240,235,300,149,360,122.7C420,96,480,128,540,170.7C600,213,660,267,720,288C780,309,840,299,900,293.3C960,288,1020,288,1080,250.7C1140,213,1200,139,1260,117.3C1320,96,1380,128,1410,144L1440,160L1440,320L1410,320C1380,320,1320,320,1260,320C1200,320,1140,320,1080,320C1020,320,960,320,900,320C840,320,780,320,720,320C660,320,600,320,540,320C480,320,420,320,360,320C300,320,240,320,180,320C120,320,60,320,30,320L0,320Z"/>
      </svg>
    </section>
  )
};

export default Slogan;